import { i18n } from "../_translations/i18n";
import { ValidationHelper } from "./";
import { URL_CONSTANTS } from "../_constants/url.constants";
import { mapLegacyHostname } from "../../Common/branding/domainMigration";

const OAUTH_AUTHORIZE_PATHS = ["/o/authorize", "/o/authorize/"];

function sameApiHost(url, api) {
    const canonical = ({ hostname, port }) => `${mapLegacyHostname(hostname) || hostname}:${port}`;
    return canonical(url) === canonical(api);
}

export class AuthenticationHelper {

    static validateEmails(emails) {
        if (emails.length === 0)
            throw new Error(i18n.t("errors.noEmailAddress"));

        emails.forEach(email => {
            if (!ValidationHelper.ValidationFns.isEmailValid(email))
                throw new Error(i18n.t("errors.emailNotValid", { email }));
        });
    }

    static processValidationEmail(email = "") {
        return email.replace(/\s/g, '+');
    }

    // next comes from the query string: only the consent screen of our API may receive the apikey.
    // Assistants linked before the domain migration still authorize on the legacy *.baintex.com host
    static isOauthNextAllowed(next, apiUrl = URL_CONSTANTS.URL_API) {
        let nextUrl, api;
        try {
            nextUrl = new URL(next);
            api = new URL(apiUrl);
        } catch (error) {
            return false;
        }

        return nextUrl.protocol === api.protocol
            && OAUTH_AUTHORIZE_PATHS.includes(nextUrl.pathname)
            && sameApiHost(nextUrl, api);
    }

    // A real form POST, so the apikey never goes in a URL and the browser sends the Origin the API checks
    static signInForOauth(apikey, next, apiUrl = URL_CONSTANTS.URL_API) {
        if (!AuthenticationHelper.isOauthNextAllowed(next, apiUrl))
            return false;

        const form = document.createElement("form");
        form.method = "POST";
        form.action = new URL(next).origin + "/o/login";
        form.style.display = "none";

        Object.entries({ apikey, next }).forEach(([name, value]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        return true;
    }
};